document.addEventListener('alpine:init', () => {
  Alpine.data('productReviews', (data) => ({
    page: 1,
    reviewsPerPage: 5,
    totalReviews: data.totalReviews,
    totalPages: Math.round(data.totalReviews / 5),
    loading: false,
    insertReviews () {
      this.page++
      this.fetchReviews(this.page, true)
    },
    async fetchReviews (page, mobile) {
      if (!mobile) {
        this.page = Number(page)
        this.loading = true;
      }
      const response = await fetch(`/partials/reviews-v2/?url=https://www.volero.nl${new URL(window.location.href).pathname}&page=${this.page}`)
      const html = await response.text()
      if (mobile) {
        document.querySelector("#product-reviews-wrapper").insertAdjacentHTML('beforeend', html)
      }
      else {
        document.querySelector("#product-reviews-wrapper").innerHTML = html
        this.loading = false;
      }

    },
  }))
})